import { OpeningTextComponent } from './OpeningTextComponent';

interface WebshopWidgetProps {
  data: string;
}

export const OpeningTextWidgetWebshop = ({ data }: WebshopWidgetProps) => {
  if (!data || data === '{}') return <></>;

  const openingTextData = JSON.parse(data);

  return (
    <OpeningTextComponent
      titleNContent={openingTextData.titleNContent}
      aligment={openingTextData.aligment}
      backgroundColor={openingTextData.backgroundColor}
      image={openingTextData.image}
      cardColor={openingTextData.cardColor}
      type={openingTextData.type}
      textColor={openingTextData.textColor}
      dividerColor={openingTextData.dividerColor}
    />
  );
};
